/*

FILE: pageLoader.js
DESCRIPTION: Page transitions and loader
AUTHOR(S): R.J. LaCount

*/

import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import anime from 'animejs/lib/anime.es.js';

import { elements } from './elements';
import { closeMobileNav } from './nav';
import { state } from './state';
import { initOnPageTransition, initAfterPageTransition } from '../app.main';
import {renderRecaptcha} from "./forms";

const initBarba = () => {

	if (state.isIE) return;

	window.barba = barba;

	barba.use(barbaPrefetch);
	barba.init({
		debug: true,
		views: [{
			namespace: 'contact',
			beforeEnter() {
				const form = document.querySelector('[data-freeform]');
				const recaptchaKey = window.freeform.recaptchaSiteKey ?? '';
				const recaptchaAction = 'submit';

				window.grecaptcha.ready(() => {
					renderRecaptcha(
						recaptchaKey,
						recaptchaAction,
						document.getElementById('g-recaptcha-response')
					);
				});
			}
		}],
		timeout: 8000,
		transitions: [
			{
				sync: false,

				leave: () => {
					return new Promise(resolve => {
						const tl = anime.timeline({
							easing: 'easeInOutQuart'
						});
						tl
							.add({
								targets: elements.transitionBars.querySelectorAll('span'),
								skew: ['-30deg'],
								duration: 0,
							});
						tl
							.add({
								targets: elements.transitionBars.querySelectorAll('span'),
								skew: ['-30deg', '-15deg'],
								translateX: ['-100%', '0%'],
								duration: 1600,
								delay: anime.stagger(150)
							});
						tl
							.add({
								targets: elements.loader,
								opacity: 1,
								duration: 600,
								complete: () => {
									closeMobileNav();
									resolve();
								}
							}, '-=900');
					});
				},

				after: () => {

					window.scrollTo(0, 0);
					initOnPageTransition();

					if (typeof htmx !== 'undefined') {
						htmx.process(document.body);
						htmx.config.requestClass = 'loading';
					}


					return new Promise(resolve => {
						const tl = anime.timeline({
							easing: 'easeInOutQuart'
						});
						tl
							.add({
								targets: elements.loader,
								opacity: 0,
								duration: 600,
								delay: 300,
							});
						tl
							.add({
								targets: elements.transitionBars.querySelectorAll('span'),
								skew: ['-30deg'],
								duration: 0,
							});
						tl
							.add({
								targets: elements.transitionBars.querySelectorAll('span'),
								skew: ['-30deg', '-15deg'],
								translateX: '100%',
								duration: 1600,
								delay: anime.stagger(150),
								complete: () => {
									initAfterPageTransition();
									resolve();
								}
							}, '-=1000');
					});
				}
			}
		]
	});
}

export { initBarba }
